import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { FormContainer } from "components/component-styles/alignment";
import FormikControl from "components/form/formikControl";
import {
  Container,
  HeaderLogin,
  LoginContainer,
  LoginFormcontainer,
  LogoContainer,
  SignUpInvitation,
} from "./index.styled";

import ReCAPTCHA from "react-google-recaptcha";
import { Link, useNavigate } from "react-router-dom";
import { env } from ".env";
import blueEmailIcon from "assets/icons/blueEmailIcon.svg";
import blueLockIcon from "assets/icons/blueLockIcon.svg";
import eyeIcon from "assets/icons/eye.svg";
import avashologo from "assets/images/logo.svg";
import { CustomButton } from "components/component-styles/buttons/index.styled";
import Shape from "components/layout/authShapes";
import SignUpModal from "components/signUpModal/SignUpModal";
import useWindowDimensions from "hooks/useWindowDimensions";
import Users from "services/apis/usersAPI";

export default function SignUp() {
  const navigate = useNavigate();
  const dim = useWindowDimensions();
  const initialValues = {
    mobile: "",
    password: "",
    confirmPassword: "",
    profile: {
      email: "",
    },
  };

  const validationSchema = Yup.object({
    email: Yup.string().email("Invalid email format"),
    password: Yup.string().required("رمز عبور الزامی می‌باشد"),
    confirmPassword: Yup.string().oneOf(
      [Yup.ref("password"), ""],
      "Passwords must match"
    ),
  });
  const captchaRef = useRef(null);
  const [captchaToken, setCaptchaToken] = useState("");
  const [isCaptchaSuccessful, setIsCaptchaSuccess] = React.useState(false);
  function onCaptchaChange(value) {
    setIsCaptchaSuccess(true);
    setCaptchaToken(value);
  }

  const [userData, setUserData] = useState(null);

  let mobile = localStorage.getItem("mobile");

  const onSubmit = async () => {
    const reqObj = {
      mobile,
      password: userData.password,
      profile: {
        email: userData.email,
      },
      token: captchaToken,
    };

    const response = await new Users(reqObj).postSignUp();

    if (response.type) {
      const { token, role, refreshToken } = response.data.data;

      toast.success(response.data?.data);
      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("role", role);

      localStorage.removeItem("mobile");
      navigate("/convert-text-to-speech");
      captchaRef.current.reset();
      window.location.reload();
    } else {
      if (response.message === "این مورد قبلا ثبت شده است.") {
        toast.warning(response.message);
        navigate("/convert-text-to-speech");
      } else {
        toast.error(response.message);
      }
    }
  };

  // <handle modal

  const [showModal, setShowModal] = useState(false);

  function handleModal(values) {
    const passwordRegex =
      /^(?!.*(.).*\1.*\1.*\1)(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!,%,&,@,#,$,^,*,?,_,~]).{8,}$/;

    const validiation = passwordRegex.test(values.password);

    if (values.confirmPassword) {
      if (validiation) {
        setUserData(values);
        setShowModal(true);
      } else {
        toast.warning(
          "رمز عبور با حداقل 6 کارکتر و ترکیب حروف بزرگ و کوچک انگلیسی و اعداد و کارکتر خاص باشد."
        );
      }
    } else {
      toast.warning("تکرار رمز عبور الزامیست.");
    }
  }

  // handle modal>

  return (
    <>
      <Helmet>
        <title>ثبت نام</title>
      </Helmet>

      <LoginContainer>
        <LogoContainer color="#89BEFF">
          <div>
            <h2>آواشو</h2>
            <img src={avashologo} alt="logo" />
          </div>
        </LogoContainer>
        <Container>
          <LoginFormcontainer>
            <HeaderLogin color="#27548C">ایجاد حساب کاربری</HeaderLogin>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleModal}
              placeholderColor="#2D3134"
              fontColor=""
            >
              {(formik) => {
                return (
                  <FormContainer>
                    <Form>
                      {/* <FormikControl
                      control="input"
                      name="mobile"
                      placeholder="شماره موبایل"
                      rightIcon={greenPhoneIcon}
                      placeholderColor="#2D3134"
                      fontColor=""
                      borderColor="#E9EBF8"
                    /> */}
                      <FormikControl
                        control="input"
                        name="email"
                        type="email"
                        placeholder="ایمیل"
                        label="ایمیل"
                        rightIcon={blueEmailIcon}
                        placeholderColor="#27548C"
                        fontColor="#27548C"
                        borderColor="#E9EBF8"
                      />
                      <FormikControl
                        control="input"
                        name="password"
                        type="password"
                        placeholder="رمز عبور"
                        label="رمز عبور"
                        toggleType={true}
                        placeholderColor="#27548C"
                        rightIcon={blueLockIcon}
                        borderColor="#E9EBF8"
                        leftIcon={eyeIcon}
                        fontColor="#27548C"
                      />
                      <FormikControl
                        control="input"
                        name="confirmPassword"
                        type="password"
                        placeholder="تکرار رمز عبور"
                        toggleType={true}
                        label="تکرار رمز عبور"
                        placeholderColor="#27548C"
                        rightIcon={blueLockIcon}
                        borderColor="#E9EBF8"
                        leftIcon={eyeIcon}
                        fontColor="#27548C"
                      />
                      <ReCAPTCHA
                        sitekey={env.REACT_APP_CAPTCHA_SITE_KEY}
                        ref={captchaRef}
                        // size="normal"
                        theme="light"
                        className="re-captcha"
                        // type="image"
                        onChange={onCaptchaChange}
                      />

                      <CustomButton
                        color="#FFFFFF"
                        background="#6CAEFF"
                        borderColor="#6CAEFF"
                        backgroundHover="#FFFFFF"
                        colorHover="#6CAEFF"
                        borderColorHover="#6CAEFF"
                        width="404px"
                        width360="320px"
                        width417="328px"
                        height="56px"
                        radius="12px"
                        // onClick={navigateToValidationCode}
                        type="submit"
                        disabled={!formik.isValid}
                      >
                        ثبت نام
                      </CustomButton>
                      <SignUpInvitation>
                        <div>
                          <span> قبلا ثبت نام کرده اید؟ از اینجا</span>

                          {dim.width > 1024 ? (
                            <Link to="/login"> وارد </Link>
                          ) : (
                            <Link to="/login">وارد </Link>
                          )}
                          <span>شوید.</span>
                        </div>
                      </SignUpInvitation>
                    </Form>
                  </FormContainer>
                );
              }}
            </Formik>
          </LoginFormcontainer>
          <Shape />
        </Container>
        {showModal && (
          <SignUpModal closing={() => setShowModal(false)} signUp={onSubmit} />
        )}
      </LoginContainer>
    </>
  );
}
